import { Injectable } from '@angular/core';
import { SettingsService } from '@app/core/settings/settings.service';
import { MemberService } from '@app/core/members/member.service';
import { Observable } from 'rxjs';
import { distinctUntilChanged, filter, map, withLatestFrom } from 'rxjs/operators';
import { Member } from '@app/core/_models/member';
import { SchemaConsents } from '@app/core/_models/schema/schema-consents';
import * as R from 'ramda';
import { MissingPropertiesService } from '@app/core/missing-properties.service';

@Injectable()
export class ForceUpdateService {

  constructor(
    private settingsService: SettingsService,
    private missingPropertiesService: MissingPropertiesService,
    private memberService: MemberService,
  ) { }

  public requireForcePropertiesUpdate$(): Observable<boolean> {
    return this.missingPropertiesService.getMissingPropertyNames().pipe(
      withLatestFrom(this.settingsService.getSettingsOnce()),
      map(([missingProperties, settings]) =>
        settings.forced_profile_update && !!missingProperties.length),
    );
  }

  public requireForceConsentUpdate$(): Observable<boolean> {
    return this.memberService.get().pipe(
      filter(Boolean),
      distinctUntilChanged(R.equals),
      withLatestFrom(this.requiredConsentsCount$),
      map(([member, count]: [Member, number]) =>
        !member.consents || Object.keys(member.consents).length < count,
      ),
    );
  }

  private get requiredConsentsCount$(): Observable<number> {
    return this.settingsService.getSettingsOnce().pipe(
      map(settings => settings.schema.consents
        ? this.totalRequiredConsentsCount(settings.schemaObject.consents)
        : 0,
      ));
  }

  private totalRequiredConsentsCount(consents: SchemaConsents): number {
    return consents.availableConsentsKeys().filter((key) => consents.isRequired(key)).length;
  }
}
